'use strict';
import $ from 'jquery';

export default class StickyScroll {
    static init(args) {
        $('.sticky-scroll').each((index, el) => {
            new StickyScroll($(el), args);
        });
    }

    constructor($el, args) {
        this.el = $el;
        if (args.offsets)
            this.offsets = args.offsets;
        this.elTop = this.el.offset().top;
        $(document).on('scroll', this.onScroll.bind(this));
    }

    onScroll(e) {
        let offset = this.getOffset();
        const scrollTop = $(document).scrollTop();
        if (scrollTop + offset > this.elTop) {
            this.el.css('position', 'sticky');
            this.el.css('top', offset);
        } else {
            this.el.css('top', 'inherit');
            this.el.css('position', 'inherit');
        }
    }

    getOffset() {
        let offset = 0;
        if (Array.isArray(this.offsets)) {
            this.offsets.forEach((el) => {
                offset += el.outerHeight() || 0;
            });
        }
        return offset;
    }
}